import React, { Fragment} from 'react';

import { processResponse } from '../../../utilities/processResponse';

import './Section.css';

const ThankYouPageSection = (props) => {
    var tempSection = props.html;
    const isAvailable = tempSection.includes('{');

    return (
        <Fragment>
            {
                props.type === "pre" ?
                <div
                    className={`${props.className} section-contain`}
                    dangerouslySetInnerHTML={{__html: processResponse(props.html)}}>
                </div>
                :
                <div
                    className={`${props.className} section-contain`}
                    dangerouslySetInnerHTML={{__html: isAvailable ? processResponse(props.html) : props.html}}>
                </div>
            }
        </Fragment>
    );
}

export default ThankYouPageSection;
